/**
 * The reason why the error page has to be shown
 */
export enum ErrorPageReason {
  GENERAL_EXCEPTION = "general_exception",
  USER_NOT_AUTHORIZED = "user_not_authorized",
}
